import { render, staticRenderFns } from "./PdfTable.vue?vue&type=template&id=255864b1&"
import script from "./PdfTable.vue?vue&type=script&lang=ts&"
export * from "./PdfTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports